import React from 'react';

// Components
import ModalV2 from '@/views/components/modals/ModalV2';
import { EditBody } from './components';

// Types
import HistoricalScenario from '@/types/historical-scenario';

interface EditModalProps {
  customScenario: HistoricalScenario;
  onClose: () => void;
  onSubmit: (scenario: Partial<HistoricalScenario>) => void;
  show: boolean;
  isLoading: boolean;
}

export const EditModal: React.FC<EditModalProps> = ({ customScenario, onClose, onSubmit, show, isLoading }) => {
  const i18nBasePath = 'Comparison.HistoricalScenarios.EditModal';
  return (
    <ModalV2
      body={<EditBody customScenario={customScenario} i18nBasePath={i18nBasePath} onClose={onClose} onSubmit={onSubmit} isLoading={isLoading} />}
      onClose={onClose}
      show={show}
      title={`${i18nBasePath}.Title`}
    />
  );
};
